//
//
//
//
//
//

import {mapGetters} from "vuex";

export default {
  name: "SectionMunicipalityAgenciesGrid",
  components: {
    AgenciesGrid: () => import("@/components/common/AgenciesGrid")
  },
  computed: {
    ...mapGetters({
      municipality_id: 'municipality/id'
    }),
    agenciesGridParams() {
      return {
        city_id: this.municipality_id,
        count: 8,
        page: 1,
      }
    },
  }
};
